import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Typography } from '@material-ui/core';
import { noop } from 'Helpers/PropTypes';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '1px',
    height: 450,
  },
  barSection: {
    display: 'flex',
    marginRight: '30%',
    width: '100%',
    minHeight: '4.5%',
  },
  barSectionHover: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.facet.whiteSmoke,
    },
  },
  bar: {
    width: 30,
    height: '100%',
  },
  barLabel: {
    paddingLeft: theme.spacing(3),
    color: theme.palette.facet.primaryGray,
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightFacetMedium,
  },
  transparent: {
    color: 'rgba(96, 96, 96, .35)',
  },
});

const HoldingBarChart = ({
  className,
  classes,
  data,
  disable,
  onSectionClick,
  selectedSection,
}) => {
  return (
    <Box
      className={classNames(classes.root, className)}
      test="holdings-bar-chart"
    >
      {data.map((sectionData) => (
        <Box
          className={classNames(classes.barSection, !disable ? classes.barSectionHover : '')}
          style={{ height: sectionData.percentageValue }}
          onClick={() => {
            if (!disable) {
              onSectionClick(sectionData.label, sectionData.id);
            }
          }}
        >
          <Box
            className={classes.bar}
            style={{ backgroundColor: sectionData.color }}
          />
          <Typography
            noWrap
            className={classNames(classes.barLabel, {
              [classes.transparent]: selectedSection && selectedSection !== sectionData.label && selectedSection !== sectionData.id,
            })}
          >
            {`${sectionData.percentageValue} ${sectionData.label}`}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

HoldingBarChart.defaultProps = {
  className: '',
  onSectionClick: noop,
  selectedSection: '',
  disable: false,
};

HoldingBarChart.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  disable: PropTypes.bool,
  onSectionClick: PropTypes.func,
  selectedSection: PropTypes.string,
};

export default withStyles(styles)(HoldingBarChart);
